/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';

function FAQ({
  intl,
  mobile,
}) {
  const messages = defineMessages(
    {
      'prospectus.course.detail.main.ofac.question': {
        id: 'prospectus.course.detail.main.ofac.question',
        description: 'This is the question for an FAQ-like section about possible location restrictions on courses.',
        defaultMessage: 'Who can take this course?',
      },
      'prospectus.course.detail.main.ofac.answer': {
        id: 'prospectus.course.detail.main.ofac.answer',
        description: 'This is a description of the legal restrictions to taking this particular course.',
        defaultMessage: 'Unfortunately, learners residing in one or more of the following countries or regions will not be able to register for this course: Iran, Cuba and the Crimea region of Ukraine. While edX has sought licenses from the U.S. Office of Foreign Assets Control (OFAC) to offer our courses to learners in these countries and regions, the licenses we have received are not broad enough to allow us to offer this course in all locations. edX truly regrets that U.S. sanctions prevent us from offering all of our courses to everyone, no matter where they live.',
      },
    },
  );

  if (mobile) {
    return (
      <div>
        <p className="mt-3">
          <strong>
            {intl.formatMessage(messages['prospectus.course.detail.main.ofac.question'])}
          </strong>
        </p>
        {intl.formatMessage(messages['prospectus.course.detail.main.ofac.answer'])}
      </div>
    );
  }
  return (
    <div>
      <h1 className="pt-3 mt-3 pt-sm-5 mt-sm-2">
        {intl.formatMessage(messages['prospectus.course.detail.main.ofac.question'])}
      </h1>
      {intl.formatMessage(messages['prospectus.course.detail.main.ofac.answer'])}
    </div>
  );
}

FAQ.propTypes = {
  intl: intlShape.isRequired,
  mobile: PropTypes.bool,
};

FAQ.defaultProps = {
  mobile: false,
};

export default injectIntl(FAQ);
